import APIUtil from "./APIUtil";

export default {

  /**
   * 异常请求结果校验
   * 
   * @param {Array} resultDataArray 异常请求一览
   */
  checkProceeResult(resultDataArray) {
    var errorFlg = false;

    // 结果检验
    for (var i = 0; i < resultDataArray.length; i++) {
      if (resultDataArray[i]) {
      } else {
        errorFlg = true;
        break;
      }
    }

    return !errorFlg;
  },

  /**
   * 菜单点击处理
   * 
   * @param {*} vueinstance VUE实例
   * @param {*} menuInfo 菜单信息
   */
  menuClickHandler(vueinstance, menuInfo) {
    sessionStorage.setItem('menuId',menuInfo.menuId)
    // 页面跳转
    if (menuInfo.menuType == "0") {
      if (menuInfo.pageId) {
        // 页面组ID
        var groupId = menuInfo.groupId;
        // 页面ID
        var pageId = menuInfo.pageId;
        // 站点ID
        var siteId = vueinstance.$route.params.site_id;

        // 页面跳转
        if (siteId) {
          vueinstance.$router.push("/" + siteId + "/" + groupId + "/" + pageId);
        } else {
          vueinstance.$router.push("/" + groupId + "/" + pageId);
        }
      } else {
        // 地址未设定
        vueinstance.$Message.error("页面不存在！");
      }
      return;
    } else if (menuInfo.menuType == "1") {
      window.open(menuInfo.pageId);
    } else if (menuInfo.menuType == "2") {
      window.location.href = menuInfo.pageId;
    }
  },
  
  /**
   * 保存控件
   * 
   * @param {any} vueInstance VUE实例
   */
  saveElementToStore(vueInstance) {
    if (vueInstance.elementIndex) {
      // 控件实例ID
      var id = "e" + vueInstance.elementIndex;
      if (vueInstance.detailIndex) {
        id += "d" + vueInstance.detailIndex;
      }

      // 保存控件实例
      vueInstance.$set(
        vueInstance.$store.getters.elementInstance,
        id,
        vueInstance.$refs.elementRef
      );
      
      // 保存父控件实例
      vueInstance.$set(
        vueInstance.$store.getters.elementInstance,
        "$" + id,
        vueInstance
      );
    }
  },

  replaceAll(str, oldString, newString) {
    return str.replace(new RegExp(oldString,"gm"),newString)
  },

  /**
   * 预授权登陆
   * 
   * @param {*} vueinstance VUE实例
   * @param {*} menuInfo 菜单信息
   */
  preAuth(vueinstance) {
    // APP保存用户登陆
    if (window.plus) {
      let userInfo = window.plus.storage.getItem("userInfo");
      if (userInfo) {
        let accessToken = window.plus.storage.getItem("accessToken");
        vueinstance.$store.commit("loginInfo", {
          accessToken: accessToken,
          userInfo: JSON.parse(userInfo),
        });
      
        return null;
      }
    }

    // 企业微信登陆
    if (vueinstance.$route.query.state == 'qywx') {
      return APIUtil.qywxUserAuth(vueinstance, vueinstance.$route.query.code);
    }

    // 域认证登陆
    if (vueinstance.$route.query.state == 'spnego') {
      return APIUtil.spnegoUserAuth(vueinstance, vueinstance.$route.query.code);
    }

    return null;
  },
}


// WEBPACK FOOTER //
// ./src/util/CommonUtil.js